import React from 'react';
// scss
import "./InputPage.css";

export default class DinoTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dinos: [
                {
                    "name": "Bob",
                    "age": 23,
                    "species": "T. Rex"
                },
                {
                    "name": "Dylan",
                    "age": 44,
                    "species": "Bracchio"
                },
                {
                    "name": "Kate",
                    "age": 32,
                    "species": "Stego"
                },
                {
                    "name": "Sally",
                    "age": 13,
                    "species": "T. Rex"
                }
            ]
        }
    }

    getRows = () => {
        let rowsHtml = this.state.dinos.map((object, index) => {
            console.log("dino table o and idx internal mapping");
            console.log(object);
            console.log(index);
            return (
                <tr>
                    <td>{object["name"]}</td>
                    <td>{object["age"]}</td>
                    <td>{object["species"]}</td>
                </tr>
            )
        });
        return rowsHtml;
    }

    getParentRows = (dinosParam) => {
        let rowsHtml = dinosParam.map((object, index) => {
            console.log("dino table o and idx external mapping");
            console.log(object);
            console.log(index);
            return (
                <tr>
                    <td>{object["name"]}</td>
                    <td>{object["age"]}</td>
                    <td>{object["species"]}</td>
                </tr>
            )
        });
        return rowsHtml;
    }

    render() {
        return (
            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Age</th>
                        <th>Species</th>
                    </tr>
                </thead>
                {this.getParentRows(this.props.rows)}
            </table>
        )
    }
}